/**
 * ARIA Collapsible Dropdown Listbox
 * @function onload
 * @desc Initialize the listbox example once the page has loaded
 * @namespace aria.ListboxButton
 */

var aria = aria || {};
var isAppleDevice = navigator.userAgent.match(/(iPod|iPhone|iPad)/) != null;

window.addEventListener('load', function () {
	var select = document.getElementsByClassName('custom-select');

	for (var i=0,l=select.length;i<l;i++){
		aria.registerCustomSelect(select[i]);
	}
	
});

aria.registerCustomSelect = function (select) {
	var button = select.getElementsByClassName('custom-select-button')[0],
		clear = select.getElementsByClassName('custom-select-clear')[0],
		listbox = select.querySelectorAll('[role="listbox"]')[0],
		listboxButton = new aria.ListboxButton(button, listbox, clear);
}

aria.ListboxButton = function (button, listbox, clear) {
	this.button = button;
	this.listboxElm = listbox;
	this.listbox = new aria.Listbox(listbox);
	this.listbox.open = false;
	this.clear = clear;
	this.registerEvents();
};

aria.ListboxButton.prototype.registerEvents = function () {
	this.button.addEventListener('click', this.showListbox.bind(this));
	this.button.addEventListener('keyup', this.checkShow.bind(this));
	this.clear.addEventListener('click', this.clearSelected.bind(this));
	this.listbox.listboxNode.addEventListener('blur', this.hideListbox.bind(this));
	this.listbox.listboxNode.addEventListener('click', this.hideListbox.bind(this));
	this.listbox.listboxNode.addEventListener('keydown', this.checkHide.bind(this));
	this.listbox.setHandleFocusChange(this.onFocusChange.bind(this));
	document.addEventListener('touchstart', this.blurButton.bind(this));
};

aria.ListboxButton.prototype.blurButton = function(evt) {
	if (evt.target != this.button && evt.target != this.listboxElm && evt.target.parentNode != this.listboxElm ) {
		this.listbox.listboxNode.blur();
	}
}

aria.ListboxButton.prototype.checkShow = function (evt) {
	var key = evt.which || evt.keyCode;

	switch (key) {
		case aria.KeyCode.UP:
		case aria.KeyCode.DOWN:
			evt.preventDefault();
			this.showListbox();
			this.listbox.checkKeyPress(evt);
			break;
	}
};

aria.ListboxButton.prototype.checkHide = function (evt) {
	var key = evt.which || evt.keyCode;

	switch (key) {
		case aria.KeyCode.RETURN:
		case aria.KeyCode.ESC:
			evt.preventDefault();
			this.hideListbox();
			this.button.focus();
			break;
	}
};

aria.ListboxButton.prototype.clearSelected = function (evt) {
	if(this.listbox.activeDescendant) {
		if(!this.listbox.activeDescendant.endsWith("_0")) {
			this.button.blur();
			evt.stopPropagation();
		}
		this.listbox.clearActiveDescendant();

		var items = this.listbox.listboxNode.querySelectorAll('.focused, [aria-selected="true"]');
		
		for(var i=0,l=items.length;i<l;i++){
			this.listbox.defocusItem(items[i]);
		};
	 this.listbox.focusFirstItem();
	 this.listbox.open = false;
	}
};

aria.ListboxButton.prototype.showListbox = function (evt) {
	//Only run this on IE
	if (/MSIE|Trident/.test(window.navigator.userAgent)) {
		var x = evt.clientX, y = evt.clientY,
		elementMouseIsOver = document.elementFromPoint(x, y);

		if(elementMouseIsOver && elementMouseIsOver.msMatchesSelector('.custom-select-clear')){
			elementMouseIsOver.click();
			return;
		}
	}

	if(this.listbox.open === true) {
		this.hideListbox();
		this.listbox.open = false;
		return;
	}
	this.listbox.listboxNode.classList.remove('hidden');
	this.button.setAttribute('aria-expanded', 'true');
	this.listbox.listboxNode.focus();
	this.listbox.open = true;
};

aria.ListboxButton.prototype.hideListbox = function () {
	this.listbox.listboxNode.classList.add('hidden');
	this.button.removeAttribute('aria-expanded');
};

aria.ListboxButton.prototype.onFocusChange = function (focusedItem) {
	this.button.childNodes[0].nodeValue = focusedItem.innerText;
};

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}
